module.exports = __webpack_public_path__ + "img/file.90c91ccb.png";